import Input from 'components/ui/Input';
import { FLOW_HEADER_HEIGHT } from 'constants/style';
import { IoSearchOutline } from 'react-icons/io5';
import { styled } from 'styled-components';

const Container = styled.div`
  position: relative;
  height: ${`${FLOW_HEADER_HEIGHT}px`};

  input {
    padding-left: 40px;
    height: 100%;
    border: none;
    font-size: 14px;
    border-radius: 0;
  }
  border-bottom: 1px solid ${(props) => props.theme.global.borderColor};
`;

const Icon = styled.div`
  position: absolute;
  top: 0;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 100%;

  svg {
    font-size: 20px;
    color: ${(props) => props.theme.global.lightTextColor};
  }
`;

interface SearchBarProps {
  keyword: string;
  onChange: (event: React.FormEvent<HTMLInputElement>) => void;
}

const SearchBar = ({ keyword, onChange }: SearchBarProps) => {
  return (
    <Container>
      <Input value={keyword} onChange={onChange} placeholder="블록을 검색해보세요" />
      <Icon>
        <IoSearchOutline />
      </Icon>
    </Container>
  );
};

export default SearchBar;
